module.exports = __webpack_public_path__ + "c8cc64a935ecb2ab60422237359690c2.pdf";